import { AbstractControl, ValidatorFn } from '@angular/forms';

export function percentageValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    if (value === null || value === '' || value === undefined) {
      return null;
    }

    // Regex to match valid numbers (integer or decimal) only
    const numberPattern = /^\d+(\.\d+)?$/;

    if (!numberPattern.test(value)) {
      return { invalidNumberFormat: true };
    }

    // Check for percentage range (0-100)
    if (value > 100 || value < 0) {
      return { percentageExceeded: true };
    }

    return null;
  };
}
